import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiComponentsModule } from '@shared/ui-components';
import { DashboardModule } from '../dashboard.module';
import { EmployeeDashboardComponent } from './employee-dashboard/employee-dashboard.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { EmployeeApprovalComponent } from './employee-approval/employee-approval.component';
import { WorkspaceOwnerModule } from '../workspace-owner/workspace-owner.module';

@NgModule({
  declarations: [EmployeeDashboardComponent, WelcomeComponent, EmployeeApprovalComponent],
  imports: [UiComponentsModule, DashboardModule, RouterModule, CommonModule, WorkspaceOwnerModule],
  providers: [],
  exports: [EmployeeDashboardComponent, WelcomeComponent],
})
export class EmployeeModule {}
